export const hireAndroidDeveloper = {

  // HirePageBanner Content
  mainBanner: {
    shortHeading: "Business-Focused Android Developers Driving Innovation",
    mainHeading: "Build Scalable <span>Android Apps</span> That Drive Growth",
    content: "Expert Android developers trusted by 20+ global businesses to create secure, high-performance mobile solutions. We help enterprises and startups build feature-rich Android applications that scale efficiently, deliver superior user experiences, and generate measurable business impact.",
  },

  // HirePageExperties Content
  flutterExpertise: {
    btnText: "Hire Android Developers For Any Service",
    shortHeading: "Our Android Development Expertise",
    heading: "Building Secure, Scalable & User-Centric Android Apps That Transform Businesses",
    description: "Our Android developers specialize in crafting native Android apps using Kotlin, Java, and Jetpack Compose, ensuring unmatched performance and seamless user experience across devices. From concept to deployment, we deliver apps that enhance engagement, productivity, and ROI.",
    servicesData: [
      {
        title: "Native Android App Development",
        description: "End-to-end development with Kotlin and Java, optimized for performance and scalability.",
        icon: "/images/hire-page-icons/flutter-icon-1.svg",
      },
      {
        title: "Custom API & Third-Party Integration",
        description: "Smooth integration with REST APIs, payment gateways, and cloud services.",
        icon: "/images/hire-page-icons/flutter-icon-2.svg",
      },
      {
        title: "UI/UX Design & Prototyping",
        description: "Intuitive and pixel-perfect interfaces that enhance usability and engagement.",
        icon: "/images/hire-page-icons/flutter-icon-3.svg",
      },
      {
        title: "Enterprise App Development",
        description: "Secure and compliant Android apps tailored for business operations and workflows.",
        icon: "/images/hire-page-icons/flutter-icon-4.svg",
      },
      {
        title: "Android App Modernization",
        description: "Upgrade legacy apps with the latest frameworks, performance tuning, and modern UI.",
        icon: "/images/hire-page-icons/flutter-icon-5.svg",
      },
      {
        title: "CI/CD Automation",
        description: "Faster builds and updates using Jenkins, GitHub Actions, and Firebase App Distribution.",
        icon: "/images/hire-page-icons/flutter-icon-6.svg",
      },
      {
        title: "App Maintenance & Support",
        description: "Continuous monitoring, updates, and optimization to ensure long-term reliability.",
        icon: "/images/hire-page-icons/flutter-icon-7.svg",
      },
      {
        title: "Play Store Publishing & Compliance",
        description: "Complete management of Play Store release process including app signing, QA testing, and policy compliance.",
        icon: "/images/hire-page-icons/flutter-icon-8.svg",
      },
    ]
  },

  ctaSection: {
    mainHeading: "Looking for Skilled Android Developers?",
    description: "Hire expert Android engineers to build fast, secure, and user-friendly mobile apps tailored to your business needs.",
    btnText: "Hire Android Developers",
    btnLink: "/contact-us",
  },

  testimonialsData: [
    {
      name: "John Richards",
      enterprise: "FinTech Solutions",
      country: "California, USA",
      profileImage: "/images/testimonials/david-shaw.avif",
      logoImage: "/images/logo-2.png",
      countryFlagImage: "/images/testimonials/flags/usa-flag.png",
      designation: "CEO at FinTech Connect",
      feedback: "Their Android team delivered an enterprise-grade fintech app that exceeded performance benchmarks. We reduced load time by 40% and boosted customer satisfaction dramatically.",
      serviceTags: ["FinTech Solutions"]
    },
    {
      name: "Lisa Nguyen",
      enterprise: "Education Technology",
      country: "Texas, USA",
      countryFlagImage: "/images/testimonials/flags/usa-flag.png",
      designation: "Product Manager at EduPlus",
      profileImage: "/images/testimonials/sophie-martinez.avif",
      logoImage: "/images/logo-2.png",
      feedback: "Our Android app launch was seamless thanks to their expert developers. We saw faster delivery cycles and an intuitive interface that our users love.",
      serviceTags: ["Education Technology"]
    },
  ],

  // DevelopmentPerformance Content (Why Choose Us)
  whyUsContent: {
    heading: " with Our Android Developers?",
    greenHeading: "Why Work",
    content: "We provide expert Android developers who specialize in creating reliable, scalable, and high-performance mobile solutions that empower your business. Our team combines advanced technical expertise, agility, and precision to help you accelerate delivery, optimize operations, and drive real business growth.",
    stats: [
      {
        title: "Support Faster Deployment",
        number: "24/7",
      },
      {
        title: "App Performance & Uptime",
        number: "99.9%",
      },
      {
        title: "Development Speed",
        number: "10x",
      },
      {
        title: "Client Satisfaction",
        number: "100%",
      },
    ],
    cta: {
      text: "Partner With us Today",
      link: "/contact-us",
    }
  },

  mlSolutionsData: [
    {
      title: "Built adaptive UIs with responsive layouts using ConstraintLayout and Compose.",
      description:
        "Our Android developers craft pixel-perfect, responsive user interfaces using ConstraintLayout and Jetpack Compose. We ensure seamless adaptability across all screen sizes, delivering consistent and intuitive user experiences.",
    },
    {
      title: "Implemented end-to-end encryption and GDPR-compliant data handling.",
      description:
        "We enforce enterprise-grade security with AES encryption, secure key storage, and GDPR-compliant data handling. Every app is built to protect user privacy and maintain full compliance with global data protection regulations.",
    },
    {
      title: "Used profiler tools to monitor performance and memory leaks.",
      description:
        "Our engineers leverage Android Profiler and LeakCanary to detect and resolve performance bottlenecks. We ensure optimal memory usage, smooth UI rendering, and fast load times across all Android devices.",
    },
    {
      title: "Created scalable APIs and error-handling mechanisms.",
      description:
        "We design and integrate RESTful APIs with robust error-handling and version control. This ensures reliable data exchange, easy scalability, and minimal downtime, even under high traffic conditions.",
    },
    {
      title: "Optimized builds and assets, reducing APK size by up to 35%.",
      description:
        "Through advanced build optimization, ProGuard configuration, and asset compression, we reduce APK sizes without sacrificing performance or visuals. This enhances app download rates and improves user retention.",
    },
  ],

  // HireCombinationSection Content
  techCombinations: {
    shortHeading: "Powerful Technology Combinations Our Android Engineers Use",
    heading: "Top Frameworks, AI Integrations, and Cloud Tools for Enterprise-Grade Android Development",
    description: "We combine modern Android technologies with AI, ML, and scalable cloud infrastructure to deliver high-performance, secure, and intelligent mobile solutions. Each combination is carefully designed to optimize speed, scalability, and real-time intelligence, helping businesses achieve measurable ROI and operational excellence.",
    combinations: [
      {
        title: "Kotlin + Jetpack Compose + TensorFlow Lite",
        description: "Build intelligent Android apps with dynamic UIs and on-device AI inference perfect for predictive recommendations, image recognition, and offline smart features.",
        icons: [
          { icon: "kotlin.svg", altText: "Kotlin programming language" },
          { icon: "jetpack-compose.svg", altText: "Jetpack Compose UI toolkit" },
        ],
      },
      {
        title: "Java + Android SDK + OpenAI API",
        description: "Integrate conversational intelligence, content generation, or virtual assistants directly into Android apps enabling smarter user engagement and real-time automation.",
        icons: [
          { icon: "java.svg", altText: "Java programming language" },
          { icon: "android-sdk.svg", altText: "Android SDK" },
        ],
      },
      {
        title: "Kotlin + Firebase + Vertex AI",
        description: "Combine Firebase's real-time backend with Google's AI platform to deliver adaptive, data-driven apps capable of personalized recommendations and predictive insights.",
        icons: [
          { icon: "kotlin.svg", altText: "Kotlin programming language" },
          { icon: "firebase.png", altText: "Firebase platform" },
        ],
      },
      {
        title: "Kotlin + ML Kit + CameraX",
        description: "Enable advanced vision-based features like barcode scanning, OCR, face detection, and augmented reality experiences ideal for logistics, fintech, and retail apps.",
        icons: [
          { icon: "kotlin.svg", altText: "Kotlin programming language" },
          { icon: "mlkit.png", altText: "ML Kit" },
        ],
      },
      {
        title: "Kotlin + AWS Amplify + SageMaker",
        description: "Create scalable Android apps powered by cloud-hosted ML models that automate processes, detect anomalies, and deliver tailored user experiences.",
        icons: [
          { icon: "kotlin.svg", altText: "Kotlin programming language" },
          { icon: "aws.svg", altText: "AWS Amplify" },
        ],
      },
      {
        title: "Kotlin + LangChain + GPT API",
        description: "Build Android apps enhanced with contextual intelligence from AI chat interfaces to workflow assistants and smart automation.",
        icons: [
          { icon: "kotlin.svg", altText: "Kotlin programming language" },
          { icon: "langchain.png", altText: "LangChain framework" },
        ],
      },
      {
        title: "Kotlin + GraphQL + Hugging Face Transformers",
        description: "Deliver AI-powered search, text summarization, and sentiment analysis with optimized, structured data fetching for complex business systems.",
        icons: [
          { icon: "kotlin.svg", altText: "Kotlin programming language" },
          { icon: "graphql.svg", altText: "GraphQL" },
        ],
      },
      {
        title: "Android Studio + Gradle + GitHub Actions",
        description: "Automate builds, testing, and deployment with CI/CD pipelines that ensure 99.9% build reliability and faster time-to-market.",
        icons: [
          { icon: "android-studio.svg", altText: "Android Studio" },
          { icon: "gradle.svg", altText: "Gradle build tool" },
        ],
      },
      {
        title: "Retrofit + OkHttp + AI Driven API Caching",
        description: "Integrate secure, high-speed communication between Android apps and AI-powered APIs with intelligent caching and response prediction.",
        icons: [
          { icon: "retrofit.svg", altText: "Retrofit" },
          { icon: "api-development.png", altText: "OkHttp" },
        ],
      },
      {
        title: "Kotlin + Room + SQLite + MLflow",
        description: "Track, version, and monitor machine learning models directly within Android data workflows ensuring reliable, reproducible AI-enabled features.",
        icons: [
          { icon: "kotlin.svg", altText: "Kotlin programming language" },
          { icon: "room.svg", altText: "Room database" },
        ],
      },
      {
        title: "Kotlin + Google Cloud Platform (GCP) + BigQuery",
        description: "Process massive datasets for analytics and AI pipelines, enabling businesses to gain actionable insights directly from mobile activity.",
        icons: [
          { icon: "kotlin.svg", altText: "Kotlin programming language" },
          { icon: "vertex-ai.png", altText: "Google Cloud Platform" },
        ],
      },
      {
        title: "Kotlin + Stripe / Razorpay + Fraud Detection Models",
        description: "Combine secure payment gateways with AI-driven fraud detection to protect transactions in eCommerce and fintech apps.",
        icons: [
          { icon: "kotlin.svg", altText: "Kotlin programming language" },
          { icon: "stripe.webp", altText: "Stripe payment gateway" },
          { icon: "razor-pay.png", altText: "Stripe payment gateway" },
        ],
      },
      {
        title: "Kotlin + Fastlane + Jenkins + AI Test Automation",
        description: "Deploy intelligent testing and monitoring workflows with automated build validation, predictive QA, and performance benchmarking.",
        icons: [
          { icon: "kotlin.svg", altText: "Kotlin programming language" },
          { icon: "jenkins.svg", altText: "Fastlane" },
        ],
      },
      {
        title: "Kotlin + n8n / Zapier + AI Agents",
        description: "Automate back-office workflows and connect Android apps with external CRMs, ERPs, or chat systems for seamless data exchange.",
        icons: [
          { icon: "kotlin.svg", altText: "Kotlin programming language" },
          { icon: "zapier.svg", altText: "Zapier automation" },
        ],
      },
      {
        title: "Kotlin + OpenCV + TensorFlow",
        description: "Power advanced computer-vision capabilities for facial recognition, quality inspection, and real-time object tracking.",
        icons: [
          { icon: "kotlin.svg", altText: "Kotlin programming language" },
          { icon: "open-cv.svg", altText: "OpenCV computer vision library" },
        ],
      },
      {
        title: "Kotlin + Snowflake + Vertex AI + Looker Studio",
        description: "Build data-intelligent Android dashboards that merge analytics, AI predictions, and visualization for smarter decision making.",
        icons: [
          { icon: "kotlin.svg", altText: "Kotlin programming language" },
          { icon: "snowflake.svg", altText: "Snow Flake" },
          { icon: "vertex-ai.png", altText: "Vertex AI" },
        ],
      },
    ]
  },

  whyChooseBitsclanContet: [
    {
      id: "Tab1",
      label: "Vetted Senior Android Talent",
      content: "Only the top 1% of Android developers qualify through our rigorous screening process. Each engineer brings 5–8 years of hands-on experience with Kotlin, Java, Jetpack Compose, and multi-module architecture delivering apps with 2x faster performance and optimized resource utilization.",
      btnText: "Connect with the clan",
      btnLink: "#",
    },
    {
      id: "Tab2",
      label: "Timezone-Aligned Collaboration",
      content: "Our teams operate within your time zone, attending daily standups, sprint reviews, and product demos in real time. This approach boosts project efficiency by up to 45%, ensuring seamless communication and faster feature delivery.",
      btnText: "Connect with the clan",
      btnLink: "#",
    },
    {
      id: "Tab3",
      label: "Proficient in Communication",
      content: "Our Android engineers are clear, proactive communicators who bridge technical and business teams effortlessly. This reduces project misalignments by 30%, resulting in faster decision-making and smoother handoffs across stakeholders.",
      btnText: "Connect with the clan",
      btnLink: "#",
    },
    {
      id: "Tab4",
      label: "Full-Stack Mobile Development Expertise",
      content: "We cover the full Android ecosystem from native Kotlin/Java development to backend integrations (Node.js, Firebase, AWS, GraphQL) and DevOps pipelines. With automated testing and continuous integration, our workflow reduces post-launch issues by over 35% while maintaining a 99.8% build success rate.",
      btnText: "Connect with the clan",
      btnLink: "#",
    },
    {
      id: "Tab5",
      label: "Scalable Teams",
      content: "Need to expand rapidly? We can scale your Android team within 48 hours, tripling delivery capacity during peak development phases without compromising on speed or quality.",
      btnText: "Connect with the clan",
      btnLink: "#",
    },
    {
      id: "Tab6",
      label: "Standard MSAs & SOWs",
      content: "We simplify onboarding with globally recognized MSA and SOW templates, cutting contract cycles by up to 60% and enabling faster project initiation with complete compliance assurance.",
      btnText: "Connect with the clan",
      btnLink: "#",
    },
    {
      id: "Tab7",
      label: "NDA & IP Protection",
      content: "Every engagement begins under strict NDA and IP ownership agreements, ensuring your source code, app architecture, and backend logic remain fully protected with zero third-party access risks.",
      btnText: "Connect with the clan",
      btnLink: "#",
    },
    {
      id: "Tab8",
      label: "Enterprise-Grade Security",
      content: "Our Android projects comply with ISO 27001, SOC 2, and GDPR standards. We implement end-to-end encryption, secure CI/CD pipelines, and restricted code repositories, reducing security vulnerabilities by over 90%.",
      btnText: "Connect with the clan",
      btnLink: "#",
    },
    {
      id: "Tab9",
      label: "Managed Delivery",
      content: "Our project leads oversee the complete delivery cycle from sprint planning to deployment and QA. With 98% on-time completion, KPI tracking, and proactive reporting, we ensure every release meets defined performance, scalability, and stability goals.",
      btnText: "Connect with the clan",
      btnLink: "#",
    },
  ],

  engagementModels: {
    shortHeading: "Engagement Models",
    heading: "Flexible Engagement Models Tailored to Your Goals",
    subheading: "Need Android expertise? Plug us in where you need us most. We adapt to your workflow, priorities, and goals whether you're scaling your mobile team, launching an Android initiative, or outsourcing end-to-end app development.",
    models: [
      {
        icon: "/images/engagement-model-gifs/hourly-icon.svg",
        index: 1,
        iconWidth: 40,
        title: "Scale with Flexible Teams",
        description: "Add pre-vetted Android developers to your in-house team to expand capacity and accelerate product delivery."
      },
      {
        icon: "/images/engagement-model-gifs/price-icon.svg",
        index: 2,
        iconWidth: 35,
        title: "Dedicated Development Teams",
        description: "Assemble a full-cycle Android team focused exclusively on your long-term projects and product roadmap."
      },
    ],
    cta: {
      text: "Talent on Your Terms",
      button: "Accelerate with Android Development",
      link: "/contact-us",
    },
  },

  // HirePageSteps Content
  hireSteps: {
    btnText: "Let's Find Your Perfect Developer",
    heading: "How to Engage Android Developers in 3 Simple Steps",
    steps: [
      {
        title: "Share Your Requirements",
        description: "Discuss your app goals, target audience, and technical needs with our Android consultants. We analyze your vision to ensure the perfect development strategy.",
        icon: "/images/hire-page-setps-icons/icon-1.svg",
      },
      {
        title: "Get Matched with Android Experts",
        description: "Within 48 hours, we'll introduce handpicked Android developers who align with your project scope, tech stack, and timeline.",
        icon: "/images/hire-page-setps-icons/icon-2.svg",
      },
      {
        title: "Start Building with Confidence",
        description: "We offer a risk-free trial period to ensure a perfect fit. If you're not satisfied, we'll provide a replacement developer at no cost.",
        icon: "/images/hire-page-setps-icons/icon-3.svg",
      },
    ],
  },

  // CoverTheStack Content
  coverTheStack: {
    whereStart: "Languages",
    shortHeading: "Tech Stack",
    mainHeading: "Comprehensive Expertise Across the Android Ecosystem",
    subHeading: "Our Android developers leverage a modern tech stack designed for performance, security, and scalability. With hands-on experience across 50+ tools and frameworks, we deliver end-to-end Android solutions from UI/UX design and development to deployment, testing, and optimization.",
    tabs: [
      "Languages",
      "Frameworks & Tools",
      "Backend & Cloud",
    ],
    tabItems: [
      { tab: "Languages", icon: "/images/tech-stack-icons/kotlin.svg", name: "Kotlin" },
      { tab: "Languages", name: "Java", icon: "/images/tech-stack-icons/java.svg", },
      { tab: "Frameworks & Tools", name: "Jetpack Compose", icon: "/images/tech-stack-icons/jetpack-compose.svg", },
      { tab: "Frameworks & Tools", icon: "/images/tech-stack-icons/android-sdk.svg", name: "Android SDK" },
      { tab: "Frameworks & Tools", icon: "/images/tech-stack-icons/android-studio.svg", name: "Android Studio" },
      { tab: "Backend & Cloud", icon: "/images/tech-stack-icons/firebase.png", name: "Firebase" },
      { tab: "Backend & Cloud", name: "AWS", icon: "/images/cloud3.png", },
      { tab: "Backend & Cloud", name: "Google Cloud", icon: "/images/cloud1.png", },
      { tab: "Backend & Cloud", name: "Node.js", icon: "/images/database9.png", },
      { tab: "Backend & Cloud", name: "GraphQL", icon: "/images/tech-stack-icons/graphql.svg", },
    ],
  },

  challengesData: [
    {
      title: "Managing Device Fragmentation",
      description: "Ensuring consistent app performance and UI across thousands of Android devices with different screen sizes, hardware capabilities, and OS versions.",
    },
    {
      title: "Ensuring App Security and Compliance",
      description: "Protecting user data, preventing reverse engineering, and complying with Google Play Store policies and regional regulations like GDPR.",
    },
    {
      title: "Optimizing Performance Across Varying Hardware",
      description: "Balancing feature richness with performance on devices with limited memory, processing power, and battery life.",
    },
    {
      title: "Handling Complex API Integrations",
      description: "Managing multiple third-party services, payment gateways, and backend systems while maintaining app stability and offline functionality.",
    },
    {
      title: "Reducing App Size and Improving Loading Speed",
      description: "Optimizing assets, code, and dependencies to minimize APK size while maintaining functionality and user experience.",
    },
  ],

  // HireExpertFacts Content
  expertFacts: {
    btnText: "book an appointment",
    heading: "Quick Facts About ",
    greenHeading: "Our Android Team",
    facts: [
      { text: "<strong>Experienced Android Developers:</strong> Our team includes highly skilled developers with expertise in Kotlin, Java, and modern Android development practices." },
      { text: "<strong>Diverse Project Experience:</strong> We've successfully worked on a wide range of mobile app projects, from startups to enterprise solutions across various industries." },
      { text: "<strong>Fast & Efficient Development:</strong> Our developers use modern Android frameworks and tools to create high-quality, scalable apps quickly and efficiently." },
      { text: "<strong>Proven Record in Mobile App Development:</strong> Our team has deep understanding of Android ecosystem, Google Play guidelines, and performance optimization techniques." },
      { text: "<strong>Cross-Device Compatibility:</strong> We specialize in creating apps that perform well across various Android devices, screen sizes, and OS versions." },
      { text: "<strong>Continuous Support:</strong> Our Android developers provide full support throughout the development process and beyond, helping with maintenance, updates, and Play Store compliance." },
    ],
    backgroundImage: `url(/images/hire-page-images/hire-flutter.avif)`,
  },

  // HirePageAppIdea Content
  appIdeaSection: {
    heading: "Not sure about your app idea? Get your prototype up in 6-8 weeks!",
    content: "Have an idea but unsure how to proceed? Our Android experts can help you build a functional prototype in just 6-8 weeks! Validate your vision, test user engagement, and establish a strong foundation for success with our expert mobile app development services.",
  },

  // HirePageEngagementModels Component Props
  hirePageEngagementModels: {
    btnText: "Get Started Now",
    headingContent: [
      { text: "Our Flexible" },
      { text: "Engagement Models" },
    ],
    discription: "Choose the engagement model that fits your project needs! Whether you need full-time, part-time, or hourly developers, we offer flexible options to ensure seamless collaboration and maximum efficiency throughout your project.",
    hiringDetails: [
      {
        text: "Hourly Hiring",
        hours: "48",
        timeUnit: "hours",
        icon: "time.svg",
        bgColor: "#FDFDFF",
        durationLabel: "Duration",
        duration: "8 Hrs/Day",
        minimumDaysLabel: "Minimum Days",
        minimumDays: "30 Days",
        billingLabel: "Billing",
        billing: "Monthly",
        startWorkPhrase: "Start work in "
      },
      {
        text: "Full Time Hiring",
        hours: "72",
        timeUnit: "hours",
        icon: "full-time.svg",
        bgColor: "#FFFEFA",
        durationLabel: "Duration",
        duration: "8 Hrs/Day",
        minimumDaysLabel: "Minimum Days",
        minimumDays: "30 Days",
        billingLabel: "Billing",
        billing: "Monthly",
        startWorkPhrase: "Get started within "
      },
      {
        text: "Part Time Hiring",
        hours: "48",
        timeUnit: "hours",
        icon: "part-time.svg",
        bgColor: "#FDFFFA",
        durationLabel: "Duration",
        duration: "8 Hrs/Day",
        minimumDaysLabel: "Minimum Days",
        minimumDays: "30 Days",
        billingLabel: "Billing",
        billing: "Monthly",
        startWorkPhrase: "Launch in "
      },
    ],
  },

  // SecondFaq Content
  faqSection: {
    mainHeading: "Frequently Asked Questions about Android Development",
    faqData: [
      {
        id: "collapseOne",
        question: "Is Kotlin better than Java for Android development?",
        answer: "Yes. Kotlin is now Google's preferred language for Android development. It offers cleaner syntax, null safety, faster execution, and better interoperability with Java libraries helping teams write more reliable and maintainable code in less time.",
      },
      {
        id: "collapseTwo",
        question: "Can Android apps integrate with external systems?",
        answer: "Absolutely. At Bitsclan IT Solutions, we regularly integrate Android apps with CRMs, ERPs, IoT devices, and third-party APIs to build a connected digital ecosystem. Whether it's real-time data exchange, sensor integration, or automation, our engineers ensure smooth, secure connectivity.",
      },
      {
        id: "collapseThree",
        question: "Do you handle Play Store publishing and compliance?",
        answer: "Yes. Our team manages the entire Play Store release process, including app signing, QA testing, and policy compliance. We also handle metadata optimization and version rollouts, ensuring your app passes all checks and reaches users without publishing issues.",
      },
      {
        id: "collapseFour",
        question: "What's the average delivery time for an Android project?",
        answer: "Delivery depends on your project's complexity. MVPs or prototypes are typically delivered within 4–6 weeks, while enterprise-grade Android apps with advanced integrations or custom modules take around 3–5 months to ensure quality, scalability, and performance.",
      },
      {
        id: "collapseFive",
        question: "Do you provide post-launch support and maintenance?",
        answer: "Yes. We offer long-term maintenance, including bug fixes, OS compatibility updates, security patches, and performance monitoring. Our goal is to keep your Android app running efficiently and compliant with the latest Google Play standards.",
      },
    ]
  },
};

export const comapnyCtaContent = {
  heading: "Ready to Build High-Performance Android Teams That Drive Results?",
  subHeading: "Let's turn your idea into a seamless mobile experience built to scale, perform, and stand out.",
  buttonText: "Let's Build Together",
}